// extracted by mini-css-extract-plugin
export var askAiIcon = "_qx-9";
export var container = "_qx-0";
export var groupSeparator = "_qx-a";
export var highlight = "_qx-4";
export var resultIcon = "_qx-5";
export var resultItem = "_qx-7";
export var resultSubtitle = "_qx-3";
export var resultTitle = "_qx-2";
export var resultsList = "_qx-1";
export var searchGroup = "_qx-6";
export var selected = "_qx-8";